module.exports = __webpack_public_path__ + "img/GameCenter.b6e3afb7.png";